import ProcurementLocationType from './ProcurementLocationTypes';

/** Lane Search Actions start */
export const getProcurementLocationListInProgress = (payload) => {
  return {
    payload,
    type: ProcurementLocationType.GET_PROCUREMENT_LOCATION_LIST,
  };
};

export const getProcurementLocationListInSuccess = (payload) => {
  return {
    payload,
    type: ProcurementLocationType.GET_PROCUREMENT_LOCATION_LIST_SUCCESS,
  };
};

export const getProcurementLocationListInFail = (payload) => {
  return {
    payload,
    type: ProcurementLocationType.GET_PROCUREMENT_LOCATION_LIST_FAIL,
  };
};

export const setProcurementLocationListRequest = (payload) => {
  return {
    payload,
    type: ProcurementLocationType.SET_PROCUREMENT_LOCATION_LIST_REQUEST,
  };
};

export const resetProcurementLocationList = (payload) => {
  return {
    payload,
    type: ProcurementLocationType.RESET_PROCUREMENT_LOCATION_LIST,
  };
};
/** Lane Search Actions end */

export const setAddNewLocation = (payload) => {
  return { payload, type: ProcurementLocationType.SET_ADD_NEW_LOCATION };
};

export const createProcurementLocationInProgress = (payload) => {
  return {
    payload,
    type: ProcurementLocationType.CREATE_UPDATE_PROCUREMENT_LOCATION,
  };
};

export const createProcurementLocationInSuccess = (payload) => {
  return {
    payload,
    type: ProcurementLocationType.CREATE_UPDATE_PROCUREMENT_LOCATION_SUCCESS,
  };
};

export const createProcurementLocationInFail = (payload) => {
  return {
    payload,
    type: ProcurementLocationType.CREATE_UPDATE_PROCUREMENT_LOCATION_FAIL,
  };
};

export const clearProcurementLocationCreation = () => {
  return {
    type: ProcurementLocationType.CLEAR_PROCUREMENT_LOCATION_CREATION,
  };
};

export const updateSelectedLocation = (payload) => {
  return { payload, type: ProcurementLocationType.UPDATE_SELECTED_LOCATION };
};

export const checkSelectionValueUpdate = (payload) => {
  return { payload, type: ProcurementLocationType.CHECK_SELECTED_LOCATION_VALUE_UPDATE };
};
